import { FC } from "react";
import { Icon, IconProps } from "../../../icons/components/Icon";
import { useTheme } from "../../../styles/theme";

export const RequisitionStatusDraftIcon: FC<IconProps> = (props) => {
  const theme = useTheme();
  return (
    <Icon height="24px" {...props} viewBox="0 0 33 33">
      <circle
        opacity="0.1"
        cx="16.5"
        cy="16.5"
        r="16.5"
        fill={theme.colors.grey}
      />
      <g clipPath="url(#clip0_10836_99601)">
        <path
          d="M17.0856 24.6018L14.7104 22.2267L19.9575 16.9796L22.3326 19.3547L17.0856 24.6018Z"
          fill={theme.colors.darkgrey}
        />
        <path
          d="M16.8179 8.58459V11.3787H19.612L16.8179 8.58459Z"
          fill={theme.colors.darkgrey}
        />
        <path
          d="M13.5082 21.7519H10.8901C10.5628 21.7519 10.2974 21.4865 10.2974 21.1592C10.2974 20.8318 10.5628 20.5664 10.8901 20.5664H14.6938L16.2744 18.9857H10.8901C10.5628 18.9857 10.2974 18.7203 10.2974 18.393C10.2974 18.0656 10.5628 17.8002 10.8901 17.8002H17.46L19.9035 15.3567C20.091 15.1691 20.1964 14.9148 20.1964 14.6496V13.5642C20.1964 13.0119 19.7487 12.5642 19.1964 12.5642H16.6322C16.0799 12.5642 15.6322 12.1165 15.6322 11.5642V9C15.6322 8.44772 15.1845 8 14.6322 8H9.30176C8.74947 8 8.30176 8.44772 8.30176 9V23.4391C8.30176 23.9914 8.74947 24.4391 9.30176 24.4391H12.5325L13.153 22.3135L13.2381 22.0221L13.5082 21.7519ZM10.2974 15.6268C10.2974 15.2994 10.5628 15.034 10.8901 15.034H17.608C17.9354 15.034 18.2008 15.2994 18.2008 15.6268C18.2008 15.9542 17.9354 16.2195 17.608 16.2195H10.8901C10.5628 16.2195 10.2974 15.9542 10.2974 15.6268Z"
          fill={theme.colors.darkgrey}
        />
        <path
          d="M20.7954 16.1412L21.6161 15.3205C22.0066 14.93 22.6398 14.93 23.0303 15.3205L23.9912 16.2814C24.3817 16.672 24.3817 17.3051 23.9912 17.6956L23.1706 18.5163L20.7954 16.1412Z"
          fill={theme.colors.darkgrey}
        />
        <path
          d="M13.7677 24.4391C13.5705 25.1147 14.1973 25.7416 14.8729 25.5444L16.0175 25.2103L14.1018 23.2946L13.7677 24.4391Z"
          fill={theme.colors.darkgrey}
        />
      </g>
      <defs>
        <clipPath id="clip0_10836_99601">
          <rect
            width="17"
            height="18"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};
